import { render, staticRenderFns } from "./advertise.vue?vue&type=template&id=80db9380&"
import script from "./advertise.vue?vue&type=script&lang=js&"
export * from "./advertise.vue?vue&type=script&lang=js&"
import style0 from "./advertise.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports